module.exports = __webpack_public_path__ + "static/chr-logo-light-a2ac5e5f84f67b64dc77061d127b76a7.svg";